import React from 'react';
import { TriangleAlert, PackageCheck, ChevronDown } from 'lucide-react';
import { ProductCard, productList } from '.';
import { tone, StatusTag, EmptyState } from './page';

export default function MissingProducts({ products }) {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const filteredProds = products?.filter((prod) => !prod?.isAvailable) || [];
    const prods = filteredProds.map((fp) => productList?.find((p) => p?.name === fp?.name)).filter(Boolean);

    return (
        <section className="shelf-card overflow-hidden">
            {/* Header */}
            <button
                type="button"
                aria-expanded={isExpanded}
                onClick={() => setIsExpanded(!isExpanded)}
                className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left bg-transparent border-0 cursor-pointer transition-colors hover:bg-surface-25">
                <span className="flex items-center gap-3 min-w-0">
                    <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[15px] ${tone('danger').chip}`}>
                        <TriangleAlert />
                    </span>
                    <span className="text-[15px] font-semibold text-surface-900 truncate">Faltantes en Anaquel</span>
                    {prods.length > 0 && (
                        <StatusTag tone="danger" className="tabular-nums">
                            {prods.length} productos
                        </StatusTag>
                    )}
                </span>
                <ChevronDown className={`text-base text-surface-400 transition-transform duration-200 ${isExpanded ? '' : '-rotate-90'}`} />
            </button>

            {/* Content */}
            {isExpanded && (
                <div className="border-t border-surface-100">
                    {prods.length === 0 ? (
                        <EmptyState icon={<PackageCheck />} title="No hay productos faltantes en el anaquel" description="Todos los productos auditados están disponibles." />
                    ) : (
                        <div className="p-5">
                            <p className="m-0 mb-4 text-xs text-surface-500">Productos que no están disponibles en el piso de venta</p>
                            <div className="flex flex-row flex-wrap gap-3">
                                {prods?.map((product, i) => (
                                    <ProductCard product={product} key={i} />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            )}
        </section>
    );
}
